module.exports = __webpack_public_path__ + "img/nav-reports.5b413f62.svg";